export const longTextWrap = {
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
} as const
